import { Subscription, timer } from 'rxjs';

export class Timmer {
    public countDown: Subscription;
    public counter: number
    public tick: number;

    constructor(time) {
        this.tick = 1000;
        this.counter = (time * 60);
    }

    startTimmer() {
        // this.counter = time * 60;
        this.countDown = timer(0, this.tick).subscribe(() => {
            if (this.counter == 0) {
                this.stopTimmer();
                return;
            }
            --this.counter;
        });
    }

    stopTimmer() {
        this.countDown.unsubscribe();
        this.counter = 0;
    }
}